import { ApiClient } from "../common/apiClient";
import { ApiResult } from "../common/apiResult";
import { formatTime, getRequestOptions } from "../common/helpers";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api`;

interface FileJobResponse {
    jobId: string;
}

interface Duration {
  start: number;
  end: number;
}

interface MetadataResponse {
  duration: Duration
}

export const FileService = {
  downloadFromUrl: async (url: string, duration: Duration, outputFormat: number, notifyByEmail: boolean, outputFileName: string): Promise<ApiResult<FileJobResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.post<FileJobResponse>(`${API_BASE}/files/download`, {
        url,
        duration: {
          start: formatTime(duration.start),
          end: formatTime(duration.end),
        },
        outputFormat,
        notifyByEmail,
        outputFileName
      }, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to download audio",
        },
      };
    }
  },
  downloadFromUpload: async (file: File, duration: Duration, outputFormat: number, notifyByEmail: boolean, outputFileName: string) : Promise<ApiResult<FileJobResponse>> => {
    const options = getRequestOptions();
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("duration.start", formatTime(duration.start));
      formData.append("duration.end", formatTime(duration.end));
      formData.append("outputFormat", outputFormat.toString());
      formData.append("notifyByEmail", `${notifyByEmail}`);
      formData.append("outputFileName", outputFileName);

      const result = await ApiClient.post<FileJobResponse>(`${API_BASE}/files/download`, formData, options);

      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to download file",
        },
      };
    }
  }, 
  getMetadata: async (url: string) : Promise<ApiResult<MetadataResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.post<MetadataResponse>(`${API_BASE}/files/metadata`, {
        url
      }, options);

      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get metadata for file",
        },
      };
    }
  }, 
};